import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { DOMLayoutDelegate as $657e4dc4a6e88df0$export$8f5ed9ff9f511381 } from "./DOMLayoutDelegate.module.js";
import { isScrollable as $eak97$isScrollable } from "@react-aria/utils";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $2a25aae57d74318e$export$a05409b8bb224a5a = /*#__PURE__*/function () {
  _createClass($2a25aae57d74318e$export$a05409b8bb224a5a, [{
    key: "isDisabled",
    value: function isDisabled(item) {
      var _item_props;
      return this.disabledBehavior === 'all' && (((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.isDisabled) || this.disabledKeys.has(item.key));
    }
  }, {
    key: "findNextNonDisabled",
    value: function findNextNonDisabled(key, getNext) {
      while (key != null) {
        var item = this.collection.getItem(key);
        if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !this.isDisabled(item)) return key;
        key = getNext(key);
      }
      return null;
    }
  }, {
    key: "getNextKey",
    value: function getNextKey(key) {
      var _this = this;
      key = this.collection.getKeyAfter(key);
      return this.findNextNonDisabled(key, function (key) {
        return _this.collection.getKeyAfter(key);
      });
    }
  }, {
    key: "getPreviousKey",
    value: function getPreviousKey(key) {
      var _this2 = this;
      key = this.collection.getKeyBefore(key);
      return this.findNextNonDisabled(key, function (key) {
        return _this2.collection.getKeyBefore(key);
      });
    }
  }, {
    key: "findKey",
    value: function findKey(key, nextKey, shouldSkip) {
      var itemRect = this.layoutDelegate.getItemRect(key);
      if (!itemRect) return null;
      // Find the item above or below in the same column.
      var prevRect = itemRect;
      do {
        key = nextKey(key);
        itemRect = this.layoutDelegate.getItemRect(key);
      } while (itemRect && shouldSkip(prevRect, itemRect));
      return key;
    }
  }, {
    key: "isSameRow",
    value: function isSameRow(prevRect, itemRect) {
      return prevRect.y === itemRect.y || prevRect.x !== itemRect.x;
    }
  }, {
    key: "isSameColumn",
    value: function isSameColumn(prevRect, itemRect) {
      return prevRect.x === itemRect.x || prevRect.y !== itemRect.y;
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      var _this3 = this;
      if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, function (key) {
        return _this3.getNextKey(key);
      }, this.isSameRow);else return this.getNextKey(key);
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      var _this4 = this;
      if (this.layout === 'grid' && this.orientation === 'vertical') return this.findKey(key, function (key) {
        return _this4.getPreviousKey(key);
      }, this.isSameRow);else return this.getPreviousKey(key);
    }
  }, {
    key: "getNextColumn",
    value: function getNextColumn(key, right) {
      return right ? this.getPreviousKey(key) : this.getNextKey(key);
    }
  }, {
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      var _this5 = this;
      // This is a temporary solution for CardView until we refactor useSelectableCollection.
      // https://github.com/orgs/adobe/projects/19/views/32?pane=issue&itemId=77825042
      var layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyRightOf' : 'getKeyLeftOf';
      if (this.layoutDelegate[layoutDelegateMethod]) {
        key = this.layoutDelegate[layoutDelegateMethod](key);
        return this.findNextNonDisabled(key, function (key) {
          return _this5.layoutDelegate[layoutDelegateMethod](key);
        });
      }
      if (this.layout === 'grid') {
        if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'rtl');else return this.findKey(key, function (key) {
          return _this5.getNextColumn(key, _this5.direction === 'rtl');
        }, this.isSameColumn);
      } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'rtl');
      return null;
    }
  }, {
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      var _this6 = this;
      var layoutDelegateMethod = this.direction === 'ltr' ? 'getKeyLeftOf' : 'getKeyRightOf';
      if (this.layoutDelegate[layoutDelegateMethod]) {
        key = this.layoutDelegate[layoutDelegateMethod](key);
        return this.findNextNonDisabled(key, function (key) {
          return _this6.layoutDelegate[layoutDelegateMethod](key);
        });
      }
      if (this.layout === 'grid') {
        if (this.orientation === 'vertical') return this.getNextColumn(key, this.direction === 'ltr');else return this.findKey(key, function (key) {
          return _this6.getNextColumn(key, _this6.direction === 'ltr');
        }, this.isSameColumn);
      } else if (this.orientation === 'horizontal') return this.getNextColumn(key, this.direction === 'ltr');
      return null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var _this7 = this;
      var key = this.collection.getFirstKey();
      return this.findNextNonDisabled(key, function (key) {
        return _this7.collection.getKeyAfter(key);
      });
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var _this8 = this;
      var key = this.collection.getLastKey();
      return this.findNextNonDisabled(key, function (key) {
        return _this8.collection.getKeyBefore(key);
      });
    }
  }, {
    key: "getKeyPageAbove",
    value: function getKeyPageAbove(key) {
      var menu = this.ref.current;
      var itemRect = this.layoutDelegate.getItemRect(key);
      if (!itemRect) return null;
      if (!(0, $eak97$isScrollable)(menu)) return this.getFirstKey();
      if (this.orientation === 'horizontal') {
        var pageX = Math.max(0, itemRect.x + itemRect.width - this.layoutDelegate.getVisibleRect().width);
        while (itemRect && itemRect.x > pageX) {
          key = this.getKeyAbove(key);
          itemRect = key == null ? null : this.layoutDelegate.getItemRect(key);
        }
      } else {
        var pageY = Math.max(0, itemRect.y + itemRect.height - this.layoutDelegate.getVisibleRect().height);
        while (itemRect && itemRect.y > pageY) {
          key = this.getKeyAbove(key);
          itemRect = key == null ? null : this.layoutDelegate.getItemRect(key);
        }
      }
      return key !== null && key !== void 0 ? key : this.getFirstKey();
    }
  }, {
    key: "getKeyPageBelow",
    value: function getKeyPageBelow(key) {
      var menu = this.ref.current;
      var itemRect = this.layoutDelegate.getItemRect(key);
      if (!itemRect) return null;
      if (!(0, $eak97$isScrollable)(menu)) return this.getLastKey();
      if (this.orientation === 'horizontal') {
        var pageX = Math.min(this.layoutDelegate.getContentSize().width, itemRect.y - itemRect.width + this.layoutDelegate.getVisibleRect().width);
        while (itemRect && itemRect.x < pageX) {
          key = this.getKeyBelow(key);
          itemRect = key == null ? null : this.layoutDelegate.getItemRect(key);
        }
      } else {
        var pageY = Math.min(this.layoutDelegate.getContentSize().height, itemRect.y - itemRect.height + this.layoutDelegate.getVisibleRect().height);
        while (itemRect && itemRect.y < pageY) {
          key = this.getKeyBelow(key);
          itemRect = key == null ? null : this.layoutDelegate.getItemRect(key);
        }
      }
      return key !== null && key !== void 0 ? key : this.getLastKey();
    }
  }, {
    key: "getKeyForSearch",
    value: function getKeyForSearch(search, fromKey) {
      if (!this.collator) return null;
      var collection = this.collection;
      var key = fromKey || this.getFirstKey();
      while (key != null) {
        var item = collection.getItem(key);
        var substring = item.textValue.slice(0, search.length);
        if (item.textValue && this.collator.compare(substring, search) === 0) return key;
        key = this.getNextKey(key);
      }
      return null;
    }
  }]);
  function $2a25aae57d74318e$export$a05409b8bb224a5a() {
    _classCallCheck(this, $2a25aae57d74318e$export$a05409b8bb224a5a);
    if (arguments.length === 1) {
      var opts = arguments.length <= 0 ? undefined : arguments[0];
      this.collection = opts.collection;
      this.ref = opts.ref;
      this.collator = opts.collator;
      this.disabledKeys = opts.disabledKeys || new Set();
      this.disabledBehavior = opts.disabledBehavior || 'all';
      this.orientation = opts.orientation || 'vertical';
      this.direction = opts.direction;
      this.layout = opts.layout || 'stack';
      this.layoutDelegate = opts.layoutDelegate || new (0, $657e4dc4a6e88df0$export$8f5ed9ff9f511381)(opts.ref);
    } else {
      this.collection = arguments.length <= 0 ? undefined : arguments[0];
      this.disabledKeys = arguments.length <= 1 ? undefined : arguments[1];
      this.ref = arguments.length <= 2 ? undefined : arguments[2];
      this.collator = arguments.length <= 3 ? undefined : arguments[3];
      this.layout = 'stack';
      this.orientation = 'vertical';
      this.disabledBehavior = 'all';
      this.layoutDelegate = new (0, $657e4dc4a6e88df0$export$8f5ed9ff9f511381)(this.ref);
    }
    // If this is a vertical stack, remove the left/right methods completely
    // so they aren't called by useDroppableCollection.
    if (this.layout === 'stack' && this.orientation === 'vertical') {
      this.getKeyLeftOf = undefined;
      this.getKeyRightOf = undefined;
    }
  }
  return $2a25aae57d74318e$export$a05409b8bb224a5a;
}();
export { $2a25aae57d74318e$export$a05409b8bb224a5a as ListKeyboardDelegate };